export default __webpack_public_path__ + "static/media/diners_club.18c57f3a.svg";